import React, { useEffect, useRef } from 'react';

/**
 * useEffect, but call the callback exactly once
 * @param {React.EffectCallback} callback The function to call
 * @param {ReadonlyArray<unknown>} when Dependency array
 * @returns {void}
 */
export const useEffectOnce = (callback: React.EffectCallback, when: React.DependencyList) => {
	const hasRunOnce = useRef(false);
	useEffect(() => {
		if (when && !hasRunOnce.current) {
			hasRunOnce.current = true;
			callback();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [callback, ...when]);
};
